module.exports = __webpack_public_path__ + "img/settings.c8136aa5.svg";